<div class="immatriculation">
  <div class="immat-left">
    <div class="euro"></div>
    <div class="france"></div>
  </div>
  <div class="value" [class.disabled]="disabled">
    <input
      [readOnly]="disabled"
      [formControl]="control"
      #searchInput
      placeholder="AB-123-CD"
      autocomplete="off"
    />
  </div>
  <div class="immat-right">
    <div class="zip" *ngIf="zipCode">{{ zipCode }}</div>
  </div>
</div>
<div class="infos">Avec ou sans espaces, tirets acceptés</div>
